var map = {
	"./baby_dress.jpg": 82,
	"./fila_black.jpg": 83,
	"./flare_dress.png": 84,
	"./shirt.jpg": 85,
	"./shop_images/analog-quartz-watch.jpg": 30,
	"./shop_images/belt.jpg": 31,
	"./shop_images/bodycon-dress.jpg": 32,
	"./shop_images/boy_boxers.jpg": 33,
	"./shop_images/boys-t-shirt.jpg": 34,
	"./shop_images/cotton-dress.jpg": 35,
	"./shop_images/crew-neck-tshirt.jpg": 36,
	"./shop_images/floral-dress.jpg": 37,
	"./shop_images/gemch_shoes.jpg": 38,
	"./shop_images/gladiator-flat-flip.jpg": 39,
	"./shop_images/gsoft-khaki.jpg": 40,
	"./shop_images/leather-shoes.jpg": 41,
	"./shop_images/princes-dress.jpg": 42,
	"./shop_images/quartz-wrist-watch.jpg": 43,
	"./shop_images/singedani-handbag.jpg": 44,
	"./shop_images/slim-fit-suit.jpg": 45,
	"./shop_images/sneakers.jpg": 46,
	"./shop_images/vest.jpg": 47,
	"./shop_images/vintage-flare-dress.jpg": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;